// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"acc9e332","654":"b7c7f9a3","772":"db7f005c","787":"b2f337de"}[chunkId] + ".chunk.js";
};